// Query page size for navigation items
// This is a COPY of packages/navigation/global-side-navigation/src/common/constants.ts
export const DEFAULT_PAGE_SIZE = 100;

export default {
	get(): number {
		return DEFAULT_PAGE_SIZE;
	},
};
